
import FetchData from '@ezviz/FetchData';
import moment from "moment";
import { message } from "antd";
import intl from 'react-intl-universal';

export const UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS";
export const GET_SELECT_PANEL_INFO = "GET_SELECT_PANEL_INFO";
export const GET_PID_PANNEL_LIST = "GET_PID_PANNEL_LIST";

moment.locale("zh-cn");

message.config({
  top: 300,
  maxCount: 3
});

export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_LOADING_STATUS,
      loading
    });
  };
}

// 获取当前产品已选择面板信息
export function getPidSelectedPanel() {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { productId } = productDetail;
    let url = `/iot/config/api/iot/support/v3/panel/withPid?pid=${productId}`;
    dispatch(updateLoadingStatus(true));
    const fetchData = new FetchData(url, {
      method: "GET",
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });

    fetchData.then(res => {
      dispatch(updateLoadingStatus(false));
      if (res && res.code == 200) {
        dispatch({
          type: GET_SELECT_PANEL_INFO,
          selectPanelInfo: res.data ? res.data : [],
        });
      } else {
        message.error(intl.get(`commmon.operate.retry`));
      }
    }).catch(e => {
      dispatch(updateLoadingStatus(false));
      message.error(intl.get(`commmon.operate.retry`));
    });
  };
}

// 获取标准面板，自定义面板，tuya面板
export function getPanelList(params, callback, failCallback) {
  return (dispatch, getState) => {
    const defaultParam = {
      firstCategory: '',
      secondCategory: '',
      pid: ""
    };
    const req = Object.assign({}, defaultParam, params);
    delete req.panelType;
    let url = `/iot/config/api/iot/support/v3/panel/panelByPid`;
    const fetchData = new FetchData(url, {
      method: "POST",
      headers: {
        "Content-Type": 'application/json'
      },
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200 && data.data) {
          const res = data.data;
          // 根据面板类型，设置不同类型的面板，"panelType": 0-标准面板，1-自定义面板，2-tuya面板
          let panelList = {
            standardPanelList: [],
            customPanelList: [],
            tuyaPanelList: {
              "panelId": "tuyapanel",
              "panelName": "涂鸦面板",
              "config": "涂鸦面板config",
              "picture": "http://eucloudfdfs.ledvanceiot.com/group1/M00/00/3F/ChAB0mVgZryALxD6AAZ_zfUxnDQ857.png",
              "rnName": "涂鸦面板",
              "rnDesc": "涂鸦面板rnDesc",
              "appVersion": "1.0.0",
              "panelType": 2,
              "status": 0,
              "version": "V1.0.0",
            },
          };
          res && res.map((item) => {
            if (item.panelType == 0) {
              panelList.standardPanelList.push(item);
            } else if (item.panelType == 1) {
              panelList.customPanelList.push(item);
            }
          });
          dispatch({
            type: GET_PID_PANNEL_LIST,
            pIdPannelList: panelList
          });
        } else {
          message.error(intl.get(`commmon.operate.retry`));
        }
      })
      .catch(e => {
        message.error(intl.get(`commmon.operate.retry`));
      });
  };
}

// 给产品选择面板
export function selectPanel(params, callback) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { productId } = productDetail;
    const defaultParam = {
      "pid": productId,
      "panelId": "",
      "panelType": 0,
      "appVersion": 'V1.0.0',
    };
    const req = Object.assign({}, defaultParam, params);
    let url = `/iot/config/api/iot/support/v3/panel/pid/select`;
    const fetchData = new FetchData(url, {
      method: "POST",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData.then(data => {
      if (data.meta && data.meta.code == 200) {
        callback && callback();
        message.success(intl.get('commmon.operate.success'));
      } else {
        message.error(data.msg || intl.get(`commmon.operate.retry`));
      }
    }).catch(e => {
      message.error(intl.get(`commmon.operate.retry`));
    });
  };
}

// 灰度/全量发布面板
export function publishPanel(params, callback) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { firmwareUpgradeCode, productId } = productDetail;
    const defaultParam = {
      pid: productId,
      firmwareUpgradeCode: firmwareUpgradeCode
    };
    const req = Object.assign({}, defaultParam, params);
    const fetchData = new FetchData(`/iot/config/api/iot/support/product/panel/publishPanel`, {
      method: "POST",
      body: req,
      headers: {
        appId: 'default',
      },
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.code == 200) {
          callback && callback();
          message.success(intl.get('commmon.operate.success'));
        } else {
          message.error(intl.get(`commmon.operate.retry`));
        }
      })
      .catch(e => {
        message.error(intl.get(`commmon.operate.retry`));
      });
  };
}


/**
 * 取消升级面板
 * @param {*} param
 */
export function cancelUpgradePanel(params, callback) {
  return (dispatch, getState) => {
    const formData = new FormData();
    formData.append('pid', params.pid);
    formData.append('panelId', params.panelId);
    formData.append('appVersion', params.appVersion);
    const fetchData = new FetchData(`/iot/config/api/iot/support/v3/panel/cancelPanelUpgrade`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: formData,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData.then(data => {
      if (data.code == 200) {
        callback && callback();
        message.success(intl.get('commmon.operate.success'));
      } else {
        message.error(intl.get(`commmon.operate.retry`));
      }
    }).catch(e => {
      message.error(intl.get(`commmon.operate.retry`));
    });
  };
}


/**
 * 设为标准面板
 * @param {*} param
 */
export function setStandardPanel(panelId, callback) {
  return (dispatch, getState) => {
    const formData = new FormData();
    formData.append('panelType', 0);
    formData.append('panelId', panelId);
    const fetchData = new FetchData(`/iot/config/api/iot/support/v3/panel/changeState`, {
      method: "POST",
      // headers: {
      //   'Content-Type': 'application/json'
      // },
      body: formData,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData.then(data => {
      if (data.code == 200) {
        callback && callback();
        message.success(intl.get('commmon.operate.success'));
      } else {
        message.error(intl.get(`commmon.operate.retry`));
      }
    }).catch(e => {
      message.error(intl.get(`commmon.operate.retry`));
    });
  };
}
